import request from '@/utils/request';

export async function queryRoles() {
  return request('/roles');
}

export async function queryUserRoles(userId) {
  return request(`/users/${userId}/roles`);
}

export async function queryPortals() {
  return request('/portals');
}

export async function queryRolePortal(roleId) {
  return request(`/roles/${roleId}/portals`);
}

export async function changeRolePortal(roleId, params) {
  return request(`/roles/${roleId}/portals/new`, {
    method: 'PUT',
    body: params,
  });
}

export async function deleteRolePortal(roleId, params) {
  return request(`/roles/${roleId}/portals`, {
    method: 'DELETE',
    body: params,
  });
}

export async function queryPrivileges() {
  return request('/roles/privileges');
}

export async function queryRolePrivilege(roleId) {
  return request(`/roles/${roleId}/privileges`);
}

export async function changeRolePrivilege(roleId, params) {
  return request(`/roles/${roleId}/grantPrivileges`, {
    method: 'POST',
    body: params,
  });
}

// POST: 新增  PUT：修改
export async function editRole(params, method = 'POST') {
  return request('/roles', {
    method,
    body: {
      ...params,
    },
  });
}

export async function deleteRole(urlIndex) {
  return request(`/roles/${urlIndex}`, {
    method: 'DELETE',
  });
}

// 查询到角色的门户之后,加载门户下的所有目录;目录有递归
export async function qryDirListByPartyId(partyId, portalId) {
  return request(`/portals/${portalId}/party/${partyId}/dirs`);
}

// 查询跟目录下的子元素
export async function qryDirListByDirId(dirId) {
  return request(`dirs/${dirId}/dirs`);
}

// 查询portals => party下的dirs
export async function qryDirsByParty(param) {
  return request(`/portals/${param.portalId}/party/${param.partyId}/dirs`);
}

// 查询roles => portal => party下的菜单
export async function qryMenuListByRoleParty(param) {
  // return request(`/roles/${param.roleId}/portals/${param.portalId}/party/${param.partyId}/menus`);
  return request(`/roles/portals/${param.portalId}/party/${param.partyId}/menus`);
}

// 查询role下的菜单
export async function qryMenuListByRole(roleId) {
  return request(`/roles/${roleId}/menus`);
}

// 获取dirs下的dirs
export async function qryDirsByDir(dirId) {
  return request(`/dirs/${dirId}/dirs`);
}

// 查询指定目录下的菜单
export async function qryMenuListByDirId(param) {
  // return request(`/roles/${param.roleId}/dirs/${param.dirId || -1}/menus`);
  return request(`/roles/dirs/${param.dirId || -1}/menus`);
}

// 更改角色菜单权限
export async function changeRoleMenu(roleId, param, method = 'POST') {
  return request(`/roles/${roleId}/privs/new`, {
    method,
    body: param,
  });
}

// 查询role => service
export async function qryServiceByRole(roleId) {
  return request(`/roles/${roleId}/services`);
}

// 删除role service
export async function deleteRoleService(param) {
  return request(`/roles/${param.roleId}/services/${param.privId}`, {
    method: 'DELETE',
  });
}

// 修改role => service
export async function editRoleService(params) {
  return request('/roles/services', {
    method: 'PUT',
    body: {
      ...params,
    },
  });
}
// 新增role => service
export async function addRoleService(roleId, params) {
  return request(`/roles/${roleId}/services`, {
    method: 'POST',
    body: {
      ...params,
    },
  });
}

export async function queryRoleComponent(roleId) {
  return request(`/roles/${roleId}/components`);
}

export async function queryComponentByMenu(param) {
  return request(`/roles/${param.roleId}/menus/${param.partyId}/components`);
}

export async function qryDirmenusByParty(param) {
  return request(`/portals/${param.portalId}/party/${param.partyId}/dirmenus`);
}

// 查询role-portal下的portlets
export async function qryPorletByPortal(params) {
  return request(`/roles/${params.roleId}/portals/${params.portalId}/portlets`);
}

// 查询role下的portlets
export async function qryPorletByRole(roleId) {
  return request(`/roles/${roleId}/portlets`);
}

// 获取types
export async function qryType() {
  return request('/portlets/types');
}

// 获取role => type => portlets
export async function qryPorletByType(param) {
  return request(`/roles/${param.roleId}/type/${param.typeId}/portlets`);
}

// 更改role portlet权限
export async function changeRolePortlet(roleId, param, method = 'POST') {
  return request(`/roles/${roleId}/privs/new`, {
    method,
    body: param,
  });
}

// data
export async function qryRoleData() {
  return request('/datapriv/dataprivs');
}

export async function qryDataPrivs(dataPrivId) {
  return request(`/datapriv/roles/dataprivs?dataPrivId=${dataPrivId}`);
}

export async function addRoleDataPrivs(payload) {
  return request('/datapriv/roles/dataprivs', {
    method: payload.method,
    body: {
      ...payload.params,
    },
  });
}
